import type { ReactNode } from 'react';

import { Box } from 'components/Box/Box';

type Props = {
  content: {
    body: ReactNode;
  };
};

export function OrgFieldCard({ content: { body } }: Props) {
  return (
    <Box py={[12, null, 24]} px={[24, null, 44]}>
      {body}
    </Box>
  );
}
